<script setup>
    import ScoreAchievement from '@/components/result/ai-literacy/ScoreAchievement.vue';  
    import AchievementTable from '@/components/result/ai-literacy/AchievementTable.vue'; 

    const userRole = 'parent';
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">
            <ScoreAchievement />
            <AchievementTable :userRole="userRole" studentLevel="4" />     
        </div>
    </div>
</template>